export default __webpack_public_path__ + "static/media/popskully-img.39b2a1a4.png";